import { changeIpRateList, addChangeIpRate, editChangeIpRate, deleteChangeIpRate } from 'api/changeIpRate';
import Cookies from 'js-cookie';

const changeIpRate = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        changeIpRateList({commit}, params) {
            return new Promise((resolve, reject) => {
                changeIpRateList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        addChangeIpRate({commit}, params) {
            return new Promise((resolve, reject) => {
                addChangeIpRate(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        editChangeIpRate({commit}, params) {
            return new Promise((resolve, reject) => {
                editChangeIpRate(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        deleteChangeIpRate({commit}, params) {
            return new Promise((resolve, reject) => {
                deleteChangeIpRate(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default changeIpRate;



// WEBPACK FOOTER //
// ./src/store/modules/changeIpRate.js